var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTragLineStarMob(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 322,
    viewBox: "0 0 48 322",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4074 6.07635C8.76673 2.18846 5.18172 7.57079 15.2165 10.8207C11.323 19.4605 16.711 23.0464 19.9609 13.0116C28.6072 16.9005 32.1931 11.5125 22.1583 8.2626C26.0462 -0.378107 20.6639 -3.96312 17.4139 6.07168L17.4074 6.07635Z",
    fill: "#FEC106"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-69.9828 655.212C-134.472 494.19 126.422 184.36 21.3012 15.9271",
    stroke: "white",
    strokeWidth: 0.910775,
    strokeDasharray: "1.82 1.82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTragLineStarMob);
export default __webpack_public_path__ + "static/media/trag-line-star-mob.b97749bf06e9b4819db06578463ef64d.svg";
export { ForwardRef as ReactComponent };